var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.queryForm.params,
                "label-position": "top",
                "label-width": "auto",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("basicData.CustomerName"),
                            prop: "customerId",
                          },
                        },
                        [
                          _c("QueryCustomerCmp", {
                            attrs: { val: _vm.queryForm.params.customerId },
                            on: {
                              change: function (val) {
                                return (_vm.queryForm.params.customerId = val)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "btn-label" },
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "permit",
                                  rawName: "v-permit:remove",
                                  value:
                                    "btn:finance:fundManagement:fundLedger:page",
                                  expression:
                                    "'btn:finance:fundManagement:fundLedger:page'",
                                  arg: "remove",
                                },
                              ],
                              attrs: {
                                icon: "el-icon-search",
                                size: "small",
                                type: "primary",
                              },
                              on: { click: _vm.searchResources },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("operationCenter.Procurar")) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { icon: "el-icon-refresh", size: "small" },
                              on: { click: _vm.onReset },
                            },
                            [_vm._v(_vm._s(_vm.$t("basicData.reset")) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c("div", { staticClass: "feet-s mb10" }, [
            _c(
              "div",
              { staticClass: "feet-r" },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permit",
                        rawName: "v-permit:remove",
                        value: "btn:finance:fundManagement:fundLedger:export",
                        expression:
                          "'btn:finance:fundManagement:fundLedger:export'",
                        arg: "remove",
                      },
                    ],
                    staticClass: "feet-btn",
                    attrs: { size: "small" },
                    on: { click: _vm.onExport },
                  },
                  [_vm._v(_vm._s(_vm.$t("receivablePayable.Export")) + " ")]
                ),
                _c("CustomStatusBar", {
                  staticClass: "feet-btn",
                  attrs: {
                    "columns-data": _vm.columns,
                    params: _vm.searchParams,
                    "save-params": _vm.customParams,
                  },
                  on: { updateColumns: _vm.updateColumns },
                }),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permit",
                        rawName: "v-permit:remove",
                        value: "btn:finance:fundManagement:fundLedger:export",
                        expression:
                          "'btn:finance:fundManagement:fundLedger:export'",
                        arg: "remove",
                      },
                    ],
                    staticClass: "feet-btn",
                    attrs: { size: "small", type: "primary" },
                    on: { click: _vm.openNotificationStrategyConfig },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("basicData.NotificationStrategyConfiguration")
                      ) + " "
                    ),
                  ]
                ),
                _c("div", { staticClass: "label" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("basicData.TotalRechargeAmount")) +
                      "：" +
                      _vm._s(_vm.formatConversion(_vm.statistics.totalAmount)) +
                      " "
                  ),
                ]),
                _c("div", { staticClass: "label" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("basicData.PreOccupiedSum")) +
                      "：" +
                      _vm._s(
                        _vm.formatConversion(_vm.statistics.occupiedAmount)
                      ) +
                      " "
                  ),
                ]),
                _c("div", { staticClass: "label" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("basicData.AmountDeductedSum")) +
                      "：" +
                      _vm._s(
                        _vm.formatConversion(_vm.statistics.deductedAmount)
                      ) +
                      " "
                  ),
                ]),
                _c("div", { staticClass: "label" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("basicData.RemainingAvailableSum")) +
                      "：" +
                      _vm._s(
                        _vm.formatConversion(_vm.statistics.availableAmount)
                      ) +
                      " "
                  ),
                ]),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              key: _vm.tableKey,
              ref: "table",
              staticClass: "table-height",
              attrs: {
                data: _vm.tableData,
                height: _vm.tableHeightRow.height,
                border: "",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("basicData.serialNumber"),
                  align: "center",
                  width: "60px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (_vm.queryForm.pageNumber - 1) *
                                _vm.queryForm.pageSize +
                                scope.$index +
                                1
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._l(_vm.currentColumns, function (item, ind) {
                return _c("el-table-column", {
                  key: ind,
                  attrs: {
                    align: item.align,
                    label: item.label,
                    "min-width": item.width,
                    prop: item.prop,
                    "show-overflow-tooltip": true,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            item.prop === "serialNo"
                              ? _c("span", { staticClass: "serialNo" }, [
                                  scope.row.isParent === true
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "batchNumber",
                                          on: {
                                            click: function ($event) {
                                              return _vm.view(2, scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(scope.row.serialNo))]
                                      )
                                    : _vm._e(),
                                ])
                              : _c("span", [
                                  _vm._v(_vm._s(scope.row[item.prop])),
                                ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  "current-page": _vm.queryForm.pageNumber,
                  "page-size": _vm.queryForm.pageSize,
                  "page-sizes": [10, 20, 50, 100, 500],
                  total: _vm.total,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "current-change": _vm.getCurrentPage,
                  "size-change": _vm.getSizePage,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            "close-on-click-modal": false,
            visible: _vm.dialogVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.closeDialog,
          },
        },
        [
          _c("template", { slot: "title" }, [
            _c("div", { staticClass: "dialog-title" }, [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("basicData.NotificationStrategyConfiguration"))
                ),
              ]),
              _c("span", { staticClass: "tips" }, [
                _c("i", { staticClass: "el-icon-info" }),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("basicData.NotificationBasedOnCustomerDimension")
                    )
                ),
              ]),
            ]),
          ]),
          _c("NotificationStrategyConfig", {
            attrs: { visible: _vm.dialogVisible },
            on: { close: _vm.closeDialog },
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }